<template>
  <div class="panel" :class="getType">
    <div class="panel__picture">
      <ProfilePicture
        v-if="accountManager"
        :url="accountManager.picture_url"
      />
      <div
        v-if="icon"
        class="panel__icon"
        :class="getIcon"
      />
    </div>
    <div class="panel-content panel__content">
      <div
        v-if="title"
        class="panel-content__title"
      >
        {{ title }}
      </div>
      <div v-if="content" class="panel-content__text">
        {{ content }}
      </div>
      <ul v-if="contentList" class="panel-content__list">
        <li v-for="listItem in contentList" :key="listItem">
          <!-- eslint-disable vue/no-v-html -->
          <span v-html="listItem" />
          <!-- eslint-enable vue/no-v-html -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProfilePicture from '@components/ProfilePicture.vue';

export default {
  components: { ProfilePicture },
  props: {
    title: { type: String, default: '' },
    content: { type: String, default: '' },
    contentList: { type: Array, default: () => [] },
    accountManager: { type: Object, default: () => {} },
    icon: { type: String, default: '' },
    type: { type: String, default: '' },
  },
  computed: {
    getType() {
      return this.type !== '' ? `panel--${this.type}` : '';
    },
    getIcon() {
      return this.icon !== '' ? `panel__icon--${this.icon}` : '';
    },
  },
};
</script>
